import type React from "react";
import { useMemo } from "react";
import { useField } from "@tanstack/react-form";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import Close from "@mui/icons-material/Close";

import type { AttributeInputProps } from "./types.ts";
import "./attribute-filter.css"

export const RokUvedeniDoProvozuOd: React.FC<AttributeInputProps> = ({
  overviewForm,
  attributesList,
  allAds,
}) => {
  const field = useField({
    form: overviewForm,
    // biome-ignore lint/nursery/noSecrets: ...
    name: "DetailCategoryFilter.RokUvedeniDoProvozuOd",
  });
  const value = useMemo(() => field.state.value, [field.state.value])

  const years: number[] = useMemo(() => {
    const unique: Record<string,number> = {};
    for (const item of allAds) {
      if(item.attributes.model) {
        const rokVyroby = item.attributes.rokUvedeniDoProvozu;
        if(rokVyroby) {
          const year: number = (new Date(rokVyroby)).getFullYear();
          unique[year] = year;
        }
      }
    }
    const result = Object.values(unique).toSorted((a: number, b: number) => a - b);
    return result;
  }, [allAds]);

  // is enabled?
  const attribute = useMemo(() => (
    // biome-ignore lint/nursery/noSecrets: <explanation>
    attributesList.find((attr) => attr.name === "RokUvedeniDoProvozu")
  ), [attributesList]);
  if (!attribute) {
    return null;
  }

  return (
    <div
      className={"SZAutoComplete"} // items are inserted after Autocomplete
    >
      <Autocomplete
        value={value ?? null}
        size="small"
        disablePortal={true}
        fullWidth={true}
        options={years}
        freeSolo={true}
        onKeyUp={(e) => {
          // We want to allow any input, even when years are not available
          // if(years.length === 0) {
          field.setValue(e.target.value);
          // }
        }}
        onChange={(_e, value) => {
          // setFilterAtom(value ?? ""); // do not reload page
          field.setValue(value ?? "");
        }}
        renderInput={(params) => (
          <TextField {...params} color="secondary" variant="filled"  label={"Rok uvedení do provozu (od)"} />
        )}
        clearIcon={
          <IconButton
            size="small"
            color="error"
            onClick={() => {
              field.setValue("");
            }}
          >
            <Close/>
          </IconButton>
        }
      />
    </div>
  );
};
